Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const transforms_1 = require("../utils/transforms");
const shared = require("@volar/shared");
function register(languageService, getTextDocument) {
    return (uri) => {
        const document = getTextDocument(uri);
        if (!document)
            return [];
        const fileName = shared.uriToFileName(document.uri);
        let entries;
        try {
            entries = languageService.getFileReferences(fileName);
        }
        catch (_a) { }
        if (!entries)
            return [];
        return (0, transforms_1.entriesToLocations)([...entries], getTextDocument);
    };
}
exports.register = register;
//# sourceMappingURL=fileReferences.js.map